module.exports = "#normalScreen{\r\n    \r\n    padding : 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/selectable-tabs/normal-screen-components/option-selection-panel/option-selection-panel.css
// module id = ./src/app/components/selectable-tabs/normal-screen-components/option-selection-panel/option-selection-panel.css
// module chunks = main